import { render, staticRenderFns } from "./DesignerV3.vue?vue&type=template&id=37bebd5b&scoped=true&"
import script from "./DesignerV3.vue?vue&type=script&lang=js&"
export * from "./DesignerV3.vue?vue&type=script&lang=js&"
import style0 from "./DesignerV3.vue?vue&type=style&index=0&id=37bebd5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bebd5b",
  null
  
)

export default component.exports